var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 16v29c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V16c0-.55.45-1 1-1h10C13.55 15 14 15.45 14 16zM13.99 7.89c0 2.98-2.52 5.1-5.99 5.1-3.41 0-5.99-2.17-5.99-5.04 0-2.86 2.52-4.94 5.99-4.94C11.36 3.01 13.83 5.02 13.99 7.89zM48 28v17c0 .55-.45 1-1 1h-9c-.552 0-1-.448-1-1V29.5c0-2.37-1.82-4.3-4.14-4.48C32.74 25 32.62 25 32.5 25s-.24 0-.36.02C29.82 25.2 28 27.13 28 29.5c0 0 0 .13 0 .25S28 30 28 30v15c0 .552-.448 1-1 1h-9c-.55 0-1-.45-1-1V16c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1.49c1.61-1.13 4.27-2.49 7.79-2.49C44.53 15 48 21.53 48 28z"}));
}

Linkedin.defaultProps = {"fill":"#FFFFFF","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
